import { apiFetch } from './client'

export type SkillType = 'common' | 'roles' | 'project'
export type SkillChannel = 'platform' | 'vault'

export interface SkillDto {
  name: string
  title: string
  path: string
  desc: string
  channel: SkillChannel
  tools: string[]
  body: string
  type: SkillType
}

export interface SkillCheck {
  ok: boolean
  message: string
}

export interface SkillDiff {
  file: string
  yamlFrontmatter: SkillCheck
  secretScan: SkillCheck
  diff: string
  canConfirm: boolean
}

export interface SkillConfirm {
  file: string
  written: true
  atomic: true
  commitStatus: string
}

export interface SkillHistoryEntry {
  hash: string
  subject: string
  author: string
  date: string
}

export function fetchSkills(type: SkillType): Promise<SkillDto[]> {
  return apiFetch<SkillDto[]>('/api/skills', { query: { type } })
}

export function fetchSkillHistory(name: string, type: SkillType): Promise<SkillHistoryEntry[]> {
  return apiFetch<SkillHistoryEntry[]>(`/api/skills/${encodeURIComponent(name)}/history`, {
    query: { type },
  })
}

export function diffSkill(name: string, content: string): Promise<SkillDiff> {
  return apiFetch<SkillDiff>(`/api/skills/${encodeURIComponent(name)}/diff`, {
    method: 'POST',
    json: { content },
  })
}

export function confirmSkill(name: string, content: string): Promise<SkillConfirm> {
  return apiFetch<SkillConfirm>(`/api/skills/${encodeURIComponent(name)}/confirm`, {
    method: 'POST',
    json: { content },
  })
}
